var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('v-main',[_c('div',{staticClass:"divMain"},[_c('v-container',{staticClass:"ctnForm",attrs:{"fluid":"","tag":"div"}},[_c('form-login',{staticClass:"fmLogin"})],1)],1)])],1)}
var staticRenderFns = []

export { render, staticRenderFns }